import { createSelector } from 'reselect';
import find from 'lodash/find';
import keys from 'lodash/keys';
import groupBy from 'lodash/groupBy';
import orderBy from 'lodash/orderBy';

import { getProductsFilteredByScore } from '../product/product.selectors';

const allIds = (state) => state.entities.productCategory.allIds;
const byId = (state) => state.entities.productCategory.byId;

const productDescriptionsById = (state) => state.entities.productDescription.byId;

export const getProductCategories = createSelector(
  [ byId, allIds, productDescriptionsById ],
  (productCategories, ids, productDescriptions) => {
    const categories = ids.map(id => {
      const category = productCategories[id];
      return {
        ...category,
        descriptions: category.descriptions.map(descriptionId => productDescriptions[descriptionId]),
      };
    });
    return orderBy(categories, ['settings.order'], ['asc']);
  }
);

export const getProductCategoriesFiltered = createSelector(
  [getProductCategories, getProductsFilteredByScore],
  (productCategories, products) => {
    const grouped = groupBy(products, product => product.productCategory);
    
    return keys(grouped).map(id => {
      return find(productCategories, { _id: id });
    });
  }
);


// WEBPACK FOOTER //
// ./src/modules/product-category/product-category.selectors.js